import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from '@ngx-translate/core';
import { catchError, EMPTY, throwError } from "rxjs";
import { Constantes } from "src/app/shared/constantes";
import { DocumentService } from "src/app/shared/services/document.service";
import { ZzzSecuriteService } from "src/app/zzz/securite/shared/securite.service";

@Component({
    selector: 'app-accueil-avec-acces',
    templateUrl: './accueil-avec-acces.component.html',
    styleUrls: ['./accueil-avec-acces.component.scss'],
    imports: [
        TranslateModule,
        RouterModule,
        CommonModule
    ]
})
export class AccueilAvecAccesComponent implements OnInit {
  #authService = inject(ZzzSecuriteService);
  estLienAuGuideUtilisateurFourni = false;

  constructor(
    private documentService: DocumentService
  ) { }

  ngOnInit() {
    try {
      const profileClaim = (<string>this.#authService.utilisateurCourant.claims.find(c => c.key === 'profil')?.value)?.split(',');
      this.estLienAuGuideUtilisateurFourni = profileClaim?.includes(Constantes.Profiles.DG_TERRITOIRE_PUBLIC);
    } catch (error) {
      console.error(`Something went wrong fetching profile claim`, error);
    }
  }

  // TODO: lorsqu'on aura un reverse proxy qui permetra de ne pas écrire les adresses complètes (à cause des paliers) on pourra
  // supprimer cette méthode et utiliser directement le lien dans fr.json comme cela:
  // 'Veuillez <a href="/sigtapi/document-pdf/nom-du-pdf.pdf" target="_blank">consultez ce guide</a> pour obtenir ...'
  openDocument(fileName: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.documentService.getPdf(fileName).subscribe({
        next: blob => {
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
          setTimeout(() => URL.revokeObjectURL(url), 30000);
        },
        error: err => {
          console.error("Erreur inattendue", err);
        }
    });
  }

}
